module.exports = __webpack_public_path__ + "img/endless_possibilities.2962e97.webp";